import React from 'react';
import { ProductCard } from '../ui/cards';
import useCategoryStore from '@/store/category.store';
import { chunkProductsWithBanners } from '@/utils/category';
import { findObjectById, modifyMenuTreeData } from '@/utils/global';
import { CategoryBanner } from '../banners';

function ProductList({ categoryId, products, lastProductRef }) {
  const { categoryTreeData } = useCategoryStore((state) => state);

  const categories = modifyMenuTreeData(categoryTreeData?.children_data);
  const selectedData =
    Array.isArray(categories) && categories?.length
      ? findObjectById(categories, 'id', categoryId)
      : null;
  const { chunks: productChunks, bannerCount } = chunkProductsWithBanners(
    products,
    selectedData?.category_banners || [],
    8
  );

  return (
    <div className='grid grid-cols-2 gap-1.5 md:grid-cols-3 lg:grid-cols-4'>
      {productChunks.map(({ products: chunk, banners }, i) => (
        <React.Fragment key={i}>
          {/* Render Products by chunk */}
          {chunk.map((product, idx) => (
            <ProductCard
              product={product}
              key={`product-${product.entity_id}-${idx}`}
            />
          ))}

          {/* Render banners */}
          {i < bannerCount && products?.length > 8 && (
            <div className='col-span-full *:my-0 *:w-full'>
              <CategoryBanner data={banners} />
            </div>
          )}
        </React.Fragment>
      ))}
      <span ref={lastProductRef}></span>
    </div>
  );
}

export default ProductList;
